import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import Avatar from 'four-nets/avatar/avatar';

import { displayedName } from 'four-nets/user/utils';
import { CommentLikersFragment } from 'four-nets/photoblog/posts/common/comments/comment-likers/comment-likers.graphql';
import { PostLikersFragment } from 'four-nets/photoblog/posts/common/footer/buttons/post-likers/post-likers.graphql';
import { UserBlogLikersFragment } from 'four-nets/photoblog/user-blog/author-side/user-blog-likers/user-blog-likers.graphql';
import { CollectionLikersFragment } from 'four-nets/photoblog/collections/collection-likers-dialog/collection-likers.graphql';
import { ImageLikersFragment } from 'four-nets/photoblog/posts/common/feed-images/description/buttons/image-likes-buttons/image-likers-dialog/image-likers-loader.graphql';

import defaultStyles from './likers-list.scss';

export interface Props {
    styles: typeof defaultStyles;
}

class LikersList extends React.PureComponent<
    Props &
        (
            | CommentLikersFragment
            | PostLikersFragment
            | UserBlogLikersFragment
            | CollectionLikersFragment
            | ImageLikersFragment
        )
> {
    render() {
        const { styles, likers } = this.props;
        return (
            <ul className={styles.list}>
                {likers?.edges &&
                    likers!.edges!.map(edge => {
                        const { id } = edge!.node!;
                        return (
                            <li className={styles.listItem} key={id}>
                                <Avatar style={{ avatar: styles.avatar }} user={edge!.node!} />
                                {edge?.node?.href ? (
                                    <Link to={edge.node.href} className={styles.label}>
                                        {displayedName(edge!.node!)}
                                    </Link>
                                ) : (
                                    <span className={styles.label}>{displayedName(edge!.node!)}</span>
                                )}
                            </li>
                        );
                    })}
            </ul>
        );
    }
}

export default Styled(defaultStyles)(LikersList);
